module.exports = "//public.getcloudapp.com/packs/media/images/checkmark-7454b119285255710c22968faf12fbee.svg";